<template>
	<div class="container-fluid">
		<div class="card card-shape home-box">
			<div class="card-header d-flex flex-row align-items-center justify-content-between">
				<h6 class="m-0 fw-bold text-green">Bulk Deposits</h6>
				<div class="d-flex">
					<b-link title="Download Excel Format" @click="downloadFile" class="fw-semibold ms-2 akkurate-green">
					 <font-awesome-icon :icon="['fas', 'download']" /></b-link>
					<b-link title="Retrive" v-b-modal.retrive-pending-deposit class="fw-semibold ms-2 akkurate-green">
					<font-awesome-icon :icon="['fas', 'circle-play']" /></b-link>
				</div>
			</div>
			<div class="card-body">
				<div class="err-accounts text-center my-2">
					<errors v-if="message">
						{{ message }}
					</errors>
				</div>
				<div class="card card-shape home-box mb-3 border border-success">
					<div class="card-body py-2">
						<div class="row mb-3">
							<div class="col-md-10">
								<transaction-form :form="form" :deposit_or_withdrawal="'Deposit'"
									:gl_options="gl_debit_options" @showExcelUploads="showExcelUploads"
									:total_amount="total_amount" :total_count="total_count">
								</transaction-form>
							</div>
							<div class="col-md-2 mt-auto">
								<b-button :disabled="isSaving" class="btn-size w-75 akkurate-green-btn"
									@click="saveBulkDeposit"><span><font-awesome-icon class="small"
											:icon="['fas', 'upload']" /></span>
									{{ action_btn }}</b-button>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<vue-good-table styleClass="vgt-table bordered striped" mode="remote" ref="allAccountTable"
							:columns="account_columns" :rows="account_rows" :isLoading.sync="isLoading"
							:totalRows="totalRecords" :select-options="{
								enabled: true,
								disableSelectInfo: true, // disable the select info panel on top
							}">
							<!-- Add your custom delete button column -->
							<template slot="table-row" slot-scope="props">
								<span v-if="props.column.field == 'transaction_date'">
									<div>{{ excelDateToYMD(props.row?.transaction_date) }}</div>
								</span>
							</template>
						</vue-good-table>
					</div>
				</div>
			</div>
		</div>
		<b-modal size="lg" id="retrive-pending-deposit" @ok="retrivePending" @show="loadInitialImports">
			<template #modal-title>
				<h6 class="fw-bold mb-0 akkurate-green">Bulk List Search</h6>
			</template>
			<retrive-form :isSearching="isSearching" :asyncFind="asyncFind" :excel_import_option="excel_import_option"
				:retrive_form="retrive_form"></retrive-form>
			<template #modal-footer="{ ok }">

				<div class="w-100">
					<b-button @click="$bvModal.hide('send-mail')" type="button"
						class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span
							class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel
						</span></b-button>
					<b-button @click="ok()" type="submit" :disabled="isSearching"
						class="akkurate-green-btn btn-size float-right border-0"><span class="small"><font-awesome-icon
								class="me-2" :icon="['fas', 'mail-forward']" />Retrive</span></b-button>
				</div>
			</template>
		</b-modal>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import TransactionForm from "./form/TransactionForm.vue";
import ApiService from "@/core/services/api.service";
import config from "@/config.js";
import Multiselect from 'vue-multiselect'
import RetriveForm from "./form/RetriveForm.vue";


export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		TransactionForm,
		Multiselect,
		RetriveForm
	},
	data() {
		return {
			...this.initialState(),
			total_amount: 0,
			total_count: 0,
			action_btn: "Upload",
			message: null,
			isSearching: false,
			// jsonData:null,
			account_columns: [
				{
					label: "New_Cust_Code",
					field: "new_customer_code",
					// width: '180px',
				},
				{
					label: "Old_Cust_Code",
					field: "old_customer_code",
					// width: '180px',
				},
				{
					label: "Staff_ID",
					field: "staff_number",
					// width: '180px',
				},
				{
					label: "Amt_(GHS)",
					field: "amount",
					// width: '10px',
				},
				{
					label: "GL_Credit",
					field: "product_type",
					type: "string",
				},
				{
					label: "Transaction_date",
					field: "transaction_date",
					type: "string",
				},
				{
					label: "Description",
					field: "description",
					type: "string",
				},
				{
					label: "Transaction Mode",
					field: "transaction_mode",
					type: "string",
				},
				{
					label: "Teller ID",
					field: "teller_id",
					type: "string",
				},
			],
			account_rows: [],
			serverParams: {
				// a map of column filters example: {name: 'john', age: '20'}
				columnFilters: {},
				sort: [
					{
						field: "", // example: 'name'
						type: "", // 'asc' or 'desc'
					},
				],
				page: 1, // what page I want to show
				perPage: 20, // how many items I'm showing per page
			},
			retrive_form: {
				excel_import: ""
			},
			excel_import_option: [],
		};
	},
	mounted() {
		this.getAccountDropdown();
		this.loadAllAccount();
	},
	methods: {
		async getAccountDropdown() {
			this.$Progress.start();
			this.isLoading = true;
			await ApiService.get("/accounts/create/dropdown")
				.then((response) => {
					// console.log(response);
					this.form.branch_option = response.data.branches;
					this.gl_debit_options = response.data.coa_subheads;
					this.isLoading = false;
					this.$Progress.finish();
				})
				.catch((error) => {
					// console.log(error);
				});
		},
		async loadAllAccount(searchFilter = null) {
			var branch_id = "";
			var acc_id = "";
			if (this.form.branch != null) {
				branch_id = this.form.branch.id;
			}
			if (this.form.acc_types != null) {
				acc_id = this.form.acc_types.id;
			}
			this.$Progress.start();
			this.isLoading = true;
			// await ApiService.post("/accounts/paginate", {
			//   page: this.serverParams.page,
			//   per_page: this.serverParams.pagePage,
			//   filter: this.form.account_number,
			//   branch_id: branch_id,
			//   account_type_id: acc_id,
			//   account_number: this.form.account_number,
			//   phone_number: this.form.phone,
			//   start_date: this.form.start_date,
			//   end_date: this.form.end_date,
			//   status: this.form.status, //Inactive,	Active, Dormant, Closed
			// })
			//   .then((response) => {
			//     console.log(response.data.data);
			//     this.account_rows = response.data.data;
			//     this.totalRecords = response.data.meta.total;
			//     this.$Progress.finish();
			//   })
			//   .catch((error) => {
			//     console.log(error);
			//   });
			this.isLoading = false;
		},

		filterTable() {
			this.loadAllAccount();
		},
		async saveBulkDeposit() {
			if (this.action_btn == 'Upload') {
				const bulk_deposit = {
					transaction_date: this.form.transaction_date,
					description: this.form.description,
					gl_debit: this.form.gl_debit,
					accounts: this.account_rows,
					excel_upload_ref: this.form.excel_upload_ref
				};
				this.isSaving = true;
				this.action_btn = 'Processing...'
				await ApiService.post(
					"/transactions/deposits/bulk/store",
					bulk_deposit
				).then((response) => {
					this.isLoadingSaving = false;
					this.$Progress.finish();

					// toast.fire({
					//   icon: "success",
					//   title: response.data.message,
					// });
					swal.fire({
						icon: "success",
						title: "Success",
						text: response.data.message,
						html: `${response.data.message} <br/> <a href="${response.data.download_url}">Download File</a>`,
						showCancelButton: false, // Show the "Cancel" button
						confirmButtonText: "OK", // Customize the text for the "OK" button
						buttonsStyling: false, // Disable SweetAlert2 styling for buttons
						customClass: {
							confirmButton:
								"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						},
					});

					this.isSaving = false;
					this.form = this.initialState().form;
					this.account_rows = [];
					this.form.gl_debit = "";
					this.action_btn = 'Upload'
				})
					.catch((error) => {
						this.isSaving = false;
						this.$Progress.fail();
						if (error.response.data) {
							this.message = error.response.data.message;
						}
						this.action_btn = 'Upload'
					});

			} else {
				this.isSaving = true;
				this.action_btn = 'Processing...'
				await ApiService.post(
					"/transactions/approve/all/deposit",
					{ 
						excel_upload_ref: this.retrive_form?.excel_import?.ref,
						excel_upload_id: this.retrive_form?.excel_import?.id
					}
				).then((response) => {
					this.isLoadingSaving = false;
					this.$Progress.finish();
					swal.fire({
						icon: "success",
						title: "Success",
						text: response.data.message,
						html: `${response.data.message} <br/> <a href="${response.data.download_url}">Download File</a>`,
						showCancelButton: false, // Show the "Cancel" button
						confirmButtonText: "OK", // Customize the text for the "OK" button
						buttonsStyling: false, // Disable SweetAlert2 styling for buttons
						customClass: {
							confirmButton:
								"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						},
					});
					this.isSaving = false;
					this.form = this.initialState().form;
					this.account_rows = [];
					this.form.gl_debit = "";
					this.action_btn = 'Upload'
				}).catch((error) => {
					this.isSaving = false;
					this.$Progress.fail();
					this.action_btn = 'Upload'
					console.log(error.response.data.message);
					if (error.response.data) {
						this.message = error.response.data.message;
					}
				});
			}
		},
		showExcelUploads(account_rows) {
			this.account_rows = account_rows;
			this.action_btn = 'Upload'
		},
		initialState() {
			return {
				totalRecords: 0,
				searchFilter: "",
				form: {
					branch: null,
					branch_option: [],
					acc_types: "",
					gl_debit: "",
					// gl_debit_option: [],
					phone: "",
					account_number: "",
					start_date: "",
					end_date: "",
					status: "",
					description: "",
					transaction_date: "",
					transaction_type: "Deposit",
					status_option: [
						"Active",
						"Inactive",
						"Dormant",
						"Closed",
					],
				},
				gl_debit_options: [],
				isLoading: true,
				isSaving: false,
				add_or_edit: "add",
			};
		},
		downloadFile() {
			// Replace 'example.pdf' with the filename you want to download from your public directory
			const fileName = "BULK_DEPOSITS_UPLOAD_TEMPLATE.xlsx";

			// console.log(fileName);

			// Construct the URL to the file in the public directory
			const fileUrl = `${config.base_url}/assets/${fileName}`;

			//   console.log(fileUrl);

			// Create a link element
			const link = document.createElement("a");
			link.href = fileUrl;
			link.download = fileName;

			// Append the link to the body
			document.body.appendChild(link);

			// Programmatically click the link to trigger the download
			link.click();

			// Remove the link from the body
			document.body.removeChild(link);
		},
		async retrivePending() {
			this.$Progress.start();
			this.isLoading = true;
			const form = {
				'excel_upload_ref': this.retrive_form?.excel_import?.ref,
				'excel_upload_id': this.retrive_form?.excel_import?.id,
				'start_date': this.retrive_form?.start_date,
				'end_date': this.retrive_form?.end_date,

			}
			await ApiService.post("/transactions/pending/deposit",form).then((response) => {
				// console.log(response);
				this.account_rows = response.data.pending_transactions;
				this.total_amount = response.data?.total_amount;
				this.total_count = response.data?.total_count;
				this.isLoading = false;
				this.$Progress.finish();
				this.action_btn = 'Approve'
			})
				.catch((error) => {
					// console.log(error);
				});
		},
		async asyncFind(query) {
			if (!query || query.length < 2) {
				this.excel_import_option = [];
				return;
			}

			this.isSearching = true;

			try {
				const response = await ApiService.post("/get-failed-excel-exports", {
					ref: query, // This will search by ref field
					per_page: 50, // Limit results
					status:'pending'
				});

				this.excel_import_option = response.data.data.data; // Assuming paginated response
				this.isSearching = false;
			} catch (error) {
				console.error('Search error:', error);
				this.excel_import_option = [];
				this.isSearching = false;
			}
		},
		async loadInitialImports() {
			this.isSearching = true;
			try {
				const response = await ApiService.post("/get-failed-excel-exports", {
					per_page: 10
				});
				this.excel_import_option = response.data.data.data; // Adjust if your data structure is different
			} catch (error) {
				this.excel_import_option = [];
			}
			this.isSearching = false;
		},

	},
};
</script>
